import _ from "lodash";
import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { Link, useParams, useRouteMatch, Route, Switch, Redirect } from "react-router-dom";
import PageTitle, { BreadCrumbs } from "components/standart/PageTitle";
import { Nav, NavLink, NavItem } from "reactstrap";
import IntlMessages from "util/intlMessages";
import { Error400 } from "views/pages";
import { adminAPI } from "redux/api";

import Form from "./Form";
import ChannelsMessages from "./Messages";

import { apiUrls, formLink } from "./init";

const { api } = adminAPI.actions;

const SpecialsInfo = (props) => {
  const { url, path } = useRouteMatch();
  const params = useParams();
  const { breadCrumbs } = props;
  const [currentTab, setCurrentTab] = useState(0);
  const [specials, setSpecials] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const onSuccess = (body) => {
      setSpecials(body);
    };
    const onFailure = ({ status }) => {
      setNotFound(404 === status);
    };

    props.getChannel({ params }, { onSuccess, onFailure });
  }, []);

  if (specials) {
    breadCrumbs.push({
      title: [specials.name].filter(_.size).join(" / "),
      url,
      actions: [
        <Link to={formLink(specials)}>
          <i className="fa fa-edit" />
        </Link>,
      ],
    });
  }
  /*
  const NavTabs = [
    {
      path: "/messages",
      title: <IntlMessages id="Specials.Casts.Messages" />,
      component: <ChannelsMessages />,
    },
    {
      path: "/form",
      title: <IntlMessages id="Specials.Casts.Form" />,
      component: <Form {...{ specials, setSpecials }} />,
    },
  ];
  */
  return (
    <>
      {notFound && <Error400 />}
      {specials ? (
        <Fragment>
          <PageTitle {...breadCrumbs} />

          <Form {...{ specials, setSpecials }} />
          <ChannelsMessages />

          {/* 
          <Route path={path}>
            <div className="mb-1">
              <Nav tabs>
                {NavTabs.map((navTab, index) => {
                  const link = url + _.toString(navTab.path);
                  return (
                    <Fragment key={index}>
                      <NavItem>
                        <span className={`nav-link ${currentTab === index ? "active" : ""}`}>
                          <Link to={link}>{navTab.title || <IntlMessages id={navTab.id} />}</Link>
                        </span>
                      </NavItem>
                    </Fragment>
                  );
                })}
              </Nav>
            </div>

            <Switch>
              {NavTabs.map((navTab, index) => {
                const link = path + _.toString(navTab.path);
                return (
                  <Route
                    key={index}
                    exact
                    path={link}
                    render={() => {
                      setCurrentTab(index);
                      return <Fragment key={index}>{navTab.component}</Fragment>;
                    }}
                  />
                );
              })}
            </Switch>

            <Route exact path={path} render={() => <Redirect to={`${url}/messages`} />} />
          </Route>
          */}
        </Fragment>
      ) : null}
    </>
  );
};

export default connect(null, {
  getChannel: api.get(apiUrls.info),
})(SpecialsInfo);
